import React from 'react';
import Image from 'next/image';
import Link from 'next/link';

import Container from 'components/container';
import { Small } from 'components/text';

import styles from './ImageBlock.module.scss';
import { ImageBlockProps } from './types';

const ImageBlock: React.FC<ImageBlockProps> = ({ block, hotelPageLink }) => {
  const { image, description, caption } = block;

  return (
    <figure
      className={caption ? styles.imageBlockCaption : styles.imageBlockButton}
    >
      {image && (
        <Container className={styles.imageBlock}>
          <Link href={hotelPageLink} passHref>
            <a target="_blank" rel="noopener noreferrer">
              <Image
                src={image}
                layout="fill"
                objectPosition="center"
                objectFit="cover"
                alt={description}
                sizes="(max-width: 1024px) 200vw, 1920px"
              />
            </a>
          </Link>
        </Container>
      )}
      {caption && (
        <figcaption>
          <Small color="grey-dark">{caption}</Small>
        </figcaption>
      )}
    </figure>
  );
};
export default ImageBlock;
